import { render, staticRenderFns } from "./MCB.vue?vue&type=template&id=a58ac2f0&"
import script from "./MCB.vue?vue&type=script&lang=js&"
export * from "./MCB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports